module.exports = __webpack_public_path__ + "assets/img/two-tab2-on.39fa5dd2.png";